import { render, staticRenderFns } from "./medical-deductions-charges-table.vue?vue&type=template&id=5716160b&"
import script from "./medical-deductions-charges-table.vue?vue&type=script&lang=js&"
export * from "./medical-deductions-charges-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports